import CloseIcon from "@mui/icons-material/Close"
import Alert from "@mui/material/Alert"
import IconButton from "@mui/material/IconButton"
import Snackbar from "@mui/material/Snackbar"
import { useDispatch, useSelector } from "react-redux"

import { closeSnackbar, selectSnackbarState } from "../../reducers/snackbar"

export default function GlobalSnackbar() {
  const { open, message } = useSelector(selectSnackbarState)
  const dispatch = useDispatch()

  function onClose() {
    dispatch(closeSnackbar())
  }

  return (
    <Snackbar
      open={open}
      onClose={onClose}
      autoHideDuration={5000}
      action={
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      }
      anchorOrigin={{
        horizontal: "right",
        vertical: "bottom",
      }}
    >
      <Alert onClose={onClose} variant="filled" color="success">
        {message}
      </Alert>
    </Snackbar>
  )
}
